<template>
    <div>
      <img :src="imgUrl" @click="show" class="thumbnail" />
      <!-- <light-box
        ref="lightbox"
        :media="data.images"
        :images="data.images"
        :show-light-box="false"
        :show-caption="false"></light-box> -->
    </div>
</template>
<script setup>
// import LightBox from 'vue-image-lightbox'
// require('vue-image-lightbox/dist/vue-image-lightbox.min.css')
import { computed, defineProps, onMounted, reactive, ref } from 'vue';

const props = defineProps({
  entryId : {
    type : Number,
    required : false
  },  
})
const lightbox = ref()
const data = reactive({
  images:[
    {
      thumb:'/app/images/entry/thumbnail/' + props.entryId,
      src:'/app/images/entry/' + props.entryId,
    }
  ]  
})

// computed
const imgUrl = computed(() => '/app/images/entry/thumbnail/' + props.entryId)

onMounted(()=>{
  console.dir(data)
})

const show = () => {
  //      this.$refs.lightbox.showImage(0)
  lightbox.value.showImage(0)
}
</script>

<!-- <script>
import LightBox from 'vue-image-lightbox'
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

export default {
  components:{
    LightBox,
  }
}
</script> -->